<template>
  <div class="controlItemWrapper" :class="control.className" :data-control-name="control.name">
    <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8 input-group">
        <multiselect
          v-model="selectedLookUp"
          :options="lookups"
          track-by="value"
          label="text"
          selectLabel
          selectedLabel
          tagPlaceholder
          placeholder
          deselectLabel
          :searchable="true"
          :allow-empty="false"
          :disabled="control.readonly"
          openDirection="bottom"
        />
      </div>
    </div>
    <div class="controlItem row" :id="control.name" v-else>
      <div class="form-group col-md-12">
        <label
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
        <div>
          <multiselect
            v-model="selectedLookUp"
            :options="lookups"
            track-by="value"
            label="text"
            selectLabel
            selectedLabel
            tagPlaceholder
            placeholder
            deselectLabel
            :searchable="true"
            :allow-empty="false"
            :disabled="control.readonly"
            openDirection="bottom"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['control', 'labelPosition'],
  data() {
    return {
      lookUpTable: null,
      selectedLookUp: { value: null, text: 'BLANK' },
    }
  },
  computed: {
    ...mapState(['dataGrid_options']),
    lookUpTableDisplayColumn() {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups() {
      const lookups = [{ value: null, text: 'BLANK' }]
      const lookUpTableVals = $getGrid(this.lookUpTable)

      if (lookUpTableVals) {
        lookUpTableVals.map(row => {
          lookups.push({
            text: row[this.lookUpTableDisplayColumn],
            value: row.rowKey,
          })
        })
      }

      return lookups
    },
  },
  created() {
    this.$nextTick(() => {
      const formBuilderInst = this.$instByClass(this, 'form-builder-root')
      this.lookUpTable = this.dataGrid_options[formBuilderInst.gridId].meta[
        this.control.propName
      ].lookUpTable
    })
  },
}
</script>
